import type { RootState } from 'state';
import type { PromocodesState } from '../slice';

function getPromocodes(state: RootState): PromocodesState['value'] {
  const { value } = state.dataService.promocodes.promocodes;
  return value;
}

export default getPromocodes;
